import StaffingModal from "./StaffingModal";
import ClientMatchesList from "../ClientMatchesList";
import { StaffingView, useStaffing } from "@/context/StaffingContext";
import { getServiceTypeFilterFromView } from "@/utils/staffingUtil";

interface ClientMatchesModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    identifier: string;
    name: string | null;
    role?: string | null;
    isApplicant: boolean;
}

const ALL_VIEWS: StaffingView[] = ['analyst', 'assistant_rbt', 'assessment'];

const ClientMatchesModal = ({ open, onOpenChange, identifier, name, role, isApplicant }: ClientMatchesModalProps) => {
    const { currentRegion, fetchPostings, postings } = useStaffing();

    const handleAddSuccess = (affectedPostingIds: Set<number>) => {
        const viewsToRefresh = ALL_VIEWS.filter(view =>
            postings[view].some(p => affectedPostingIds.has(p.Id))
        );
        (viewsToRefresh.length > 0 ? viewsToRefresh : ALL_VIEWS).forEach(view =>
            fetchPostings(view, {
                filter: `region eq '${currentRegion}' ${getServiceTypeFilterFromView(view)}`,
                expand: ['processes,client'],
                orderby: 'id desc',
            })
        );
    };

    return (
        <StaffingModal
            open={open}
            onOpenChange={onOpenChange}
            title={`Matched Clients — ${name}`}
            wide
        >
            <ClientMatchesList
                identifier={identifier}
                isApplicant={isApplicant}
                region={currentRegion}
                widget={false}
                active={open}
                staffFullName={name}
                staffRole={role}
                onAddSuccess={handleAddSuccess}
            />
        </StaffingModal>
    );
};

export default ClientMatchesModal;
